import { render, staticRenderFns } from "./packsack.vue?vue&type=template&id=8b327e22&scoped=true&"
import script from "./packsack.vue?vue&type=script&lang=js&"
export * from "./packsack.vue?vue&type=script&lang=js&"
import style0 from "./packsack.vue?vue&type=style&index=0&id=8b327e22&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b327e22",
  null
  
)

export default component.exports